/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

class OutlinedPasswordInput extends Component {
  constructor(props) {
    super(props);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.state = { showPassword: false };
  }

  handleClickShowPassword() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  // eslint-disable-next-line class-methods-use-this
  handleMouseDownPassword(event) {
    event.preventDefault();
  }

  render() {
    const {
      autoComplete,
      id,
      name,
      onChange,
      label: propsLabel,
    } = this.props;
    const label = propsLabel || 'Senha';
    const { showPassword } = this.state;

    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <OutlinedInput
          {...this.props}
          id={id}
          type={showPassword ? 'text' : 'password'}
          required
          onChange={onChange}
          label={label}
          name={name || 'password'}
          endAdornment={(
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={this.handleClickShowPassword}
                onMouseDown={this.handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          )}
          autoComplete={autoComplete || 'current-password'}
        />
      </FormControl>
    );
  }
}

OutlinedPasswordInput.propTypes = {
  autoComplete: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default OutlinedPasswordInput;
